import { StoreState } from "@futrli/auth";
import { get } from "lodash";

export const getCurrentUserId = (state: StoreState) => {
  return (get(state, 'authReducers.authenticatedUser.username') as string) || undefined;
};
